import React, { useState } from 'react';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import showAlert from '../../common/utils/alert';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';

export const Environment = ({
  environment,
  generateProjectEnvURL,
  toggle,
  deleteEnvironment,
  domainName,
  seoName,
  upgrade,
  updateEnvironmentProject,
  projectId,
  version,
  deleteFlag,
}) => {
  const [envName, setEnvName] = useState(environment.name);
  return (
    <tr key={environment.uuid}>
      <td>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-prepend" title="Environment Name">
              <span className="input-group-text">
                <i className={`wb ${iconForField('text')}`}></i>
              </span>
            </div>
            <input
              className="form-control form-control-sm"
              placeholder="Name of Constant"
              type="text"
              name="name"
              value={envName}
              onChange={(e) => {
                setEnvName(e.target.value);
              }}
            />
          </div>
        </div>
      </td>
      <td>{environment.envType}</td>
      <td>{generateProjectEnvURL(environment.envType, domainName, seoName)}</td>
      <td>
        <button
          type="button"
          className="btn btn-theme-submit btn-xs"
          onClick={() => {
            if (upgrade) {
              toggle();
            } else {
              environment.name = envName;
              updateEnvironmentProject({ projectId, version, environment, uuid: environment.uuid });
            }
          }}
        >
          <i className={`wb ${drapcodeIcon('update')}`}></i>
        </button>
        &nbsp;
        <button
          type="button"
          className="btn btn-theme-delete btn-xs"
          onClick={
            deleteFlag
              ? () => {
                  if (upgrade) {
                    toggle();
                  } else {
                    const text = "You won't be able to revert it!";
                    const confirmButtonText = 'Yes, delete it!';
                    const preConfirm = () => {
                      return deleteEnvironment(environment.uuid);
                    };
                    showAlert(text, preConfirm, confirmButtonText);
                  }
                }
              : undefined
          }
        >
          <i className={`wb ${drapcodeIcon('delete')}`}></i>&nbsp;
          {deleteFlag ? null : (
            <TooltipInfo
              title={description}
              headerText={`Permission Disabled!`}
              showHeader={true}
              showArrow={true}
            />
          )}
        </button>
      </td>
    </tr>
  );
};
